/**
 * Clean dashboard background based on AI Risk Hub
 */
import React from 'react';
import { Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';

const GradientBackground: React.FC = () => {
  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';

  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: -1,
        overflow: 'hidden',
        // White to very light gray base
        background: isDark
          ? '#121212'
          : '#F8F9FA', 
      }}
    >
      {/* Light Faded Orange Glow - Top Left */}
      <Box
        sx={{
          position: 'absolute',
          top: '5%',
          left: '5%',
          width: '30%',
          height: '30%',
          borderRadius: '50%',
          background: isDark
            ? 'radial-gradient(circle, rgba(255, 87, 51, 0.3) 0%, rgba(255, 87, 51, 0) 70%)'
            : 'radial-gradient(circle, rgba(255, 140, 66, 0.3) 0%, rgba(255, 140, 66, 0) 70%)',
          filter: 'blur(80px)',
        }}
      />

      <Box
        sx={{
          position: 'absolute',
          top: '5%',
          left: '85%',
          width: '20%',
          height: '20%',
          borderRadius: '50%',
          background: isDark
            ? 'radial-gradient(circle, rgba(255, 87, 51, 0.3) 0%, rgba(255, 87, 51, 0) 70%)'
            : 'radial-gradient(circle, rgba(255, 140, 66, 0.3) 0%, rgba(255, 140, 66, 0) 70%)',
          filter: 'blur(80px)',
        }}
      />

      <Box
        sx={{
          position: 'absolute',
          top: '45%',
          left: '35%',
          width: '20%',
          height: '20%',
          borderRadius: '50%',
          background: isDark
            ? 'radial-gradient(circle, rgba(255, 87, 51, 0.3) 0%, rgba(255, 87, 51, 0) 70%)'
            : 'radial-gradient(circle, rgba(255, 140, 66, 0.3) 0%, rgba(255, 140, 66, 0) 70%)',
          filter: 'blur(80px)',
        }}
      />

      {/* Light Faded Orange Glow - Bottom Right */}
      <Box
        sx={{
          position: 'absolute',
          bottom: '-10%',
          right: '-5%',
          width: '35%',
          height: '35%',
          borderRadius: '50%',
          background: isDark
            ? 'radial-gradient(circle, rgba(255, 140, 66, 0.3) 0%, rgba(255, 140, 66, 0) 70%)'
            : 'radial-gradient(circle, rgba(255, 179, 102, 0.3) 0%, rgba(255, 179, 102, 0) 900%)',
          filter: 'blur(100px)',
        }}
      />
    </Box>
  );
};

export default GradientBackground;